import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./Icon.module.css";

const Icon: React.FC<IconProps> = ({ children, type, className, rounded }) => (
  <div
    className={classNames(styles.icon, className, {
      [styles.contrast]: type === "contrast",
      [styles.complementary]: type === "complementary",
      [styles.complementaryContrast]: type === "complementaryContrast",
      [styles.accent]: type === "accent",
      [styles.info]: type === "info",
      [styles.success]: type === "success",
      [styles.error]: type === "error",
      [styles.warn]: type === "warn",
      [styles.muted]: type === "muted",
      [styles.rounded]: rounded,
    })}
  >
    {children}
  </div>
);

type IconProps = {
  children?: ReactNode;
  className?: string;
  type:
    | "main"
    | "contrast"
    | "complementary"
    | "complementaryContrast"
    | "accent"
    | "info"
    | "success"
    | "error"
    | "warn"
    | "muted";
  rounded?: boolean;
};

export default Icon;
